<script setup>
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";

defineProps({
  applyingDiscount: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[1035px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <ModalHeader>
            <ModalHeading>
              <strong>Wait!</strong> Would you like to save 50% for the next 3 months? 🎉
            </ModalHeading>

            <div class="tw-flex tw-flex-col tw-gap-4">
              <ModalSubText>
                We know that everyone needs a helping hand every now and then.
              </ModalSubText>
              <ModalSubText>
                As we value you as a customer and do not want to lose you, we want to offer you 50% off your Hike subscription for the next 3 months.
              </ModalSubText>
              <ModalSubText>
                If that sounds of interest just click the 'Yes, Give me 50% off for 3 months' button below and the discount will be applied automatically. Your subscription will continue as normal after this 3 month period.
              </ModalSubText>
              <ModalSubText>
                <strong>The 50% off discount cannot be used in conjunction with any other deals on your account.</strong>
              </ModalSubText>
            </div>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-items-center tw-justify-end tw-gap-4">
          <DefaultButton
            variant="primary-inverted"
            :disabled="applyingDiscount"
            @click="emit('close')"
          >
            No Thanks
          </DefaultButton>
          <DefaultButton
            :disabled="applyingDiscount"
            @click="emit('confirm')"
          >
            Yes, Give me 50% off for 3 months
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>

